"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
var OfferCreateOrEdit_1 = require("./OfferCreateOrEdit");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return OfferCreateOrEdit_1.OfferCreateOrEdit; } });
